// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--dcl-art-con-bo-str {
    width: 100%;
}

.scl--dcl-step-content {
    position: absolute;
    top: -90px;
    transform: translateX(-40%);
    width: 300px;
    min-height: 80px;
    transition: left 0.35s cubic-bezier(0.4, 0, 0.2, 1), transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: start;
}

.scl--dcl-step-content h3 {
    color: var(--color-text-primary);
    font-family: var(--primary-font);
    margin: 0;
    font-size: var(--font-size-body-sm);
    font-weight: lighter;
}

.scl--dcl-step-content p {
    font-size: var(--font-size-body-ssm);
    color: var(--color-text-third);
    margin: 0;
    font-weight: lighter;
    font-family: var(--primary-font);
}

/* Line */
.scl--dacbs-stl-pos {
    width: 100%;
    position: relative;
    padding-top: 24px;
}

.scl--dsp-stl-lin-cont {
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg,
            rgba(255, 255, 255, 0.8),
            rgba(185, 185, 185, 0.8));
}

/* Dots */
.scl--dacbs-step-dots {
    position: absolute;
    top: 20px;
    width: 100%;
}

.scl--dslc-step-inner {
    position: absolute;
    top: 0;
    left: 200px;
    right: 200px;
    height: 100%;
}

.scl--sdt-step-dot {
    position: absolute;
    transform: translateX(-50%);
    background: transparent;
    border: none;
    cursor: pointer;
    text-align: center;
    min-width: 65px;
}

.scl--sdt-step-dot::before {
    content: '';
    width: 10px;
    height: 10px;
    background: rgba(125, 129, 135, 1);
    display: block;
    margin: 0 auto;
    transition: 0.2s ease;
}

.scl--sdt-step-dot.active::before {
    background: #fff;
    transform: scale(1.3);
}

.scl--step-label {
    margin-top: 8px;
    font-size: 16px;
    color: rgba(125, 129, 135, 1);
    display: block;
    font-family: var(--primary-font);
}

.scl--sdt-step-dot.active .scl--step-label {
    color: var(--color-text-primary);
    font-size: 16px;
    font-family: var(--primary-font);
}

.scl--dcl-step-content[data-edge="start"] {
    transform: translateX(0);
}

.scl--dcl-step-content[data-edge="end"] {
    transform: translateX(-100%);
}

.scl--step-dots-track {
    position: relative;
    width: 100%;
    height: 100%;
    transition: transform 0.4s ease;
}

.scl--step-dots-track.shifted {
    transform: translateX(-12.5%);
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/company/css/dynamicLine.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,iGAAiG;IACjG,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,SAAS;IACT,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,SAAS;IACT,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA,SAAS;AACT;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX;;qCAEiC;AACrC;;AAEA,SAAS;AACT;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,cAAc;IACd,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,6BAA6B;IAC7B,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".scl--dcl-art-con-bo-str {\n    width: 100%;\n}\n\n.scl--dcl-step-content {\n    position: absolute;\n    top: -90px;\n    transform: translateX(-40%);\n    width: 300px;\n    min-height: 80px;\n    transition: left 0.35s cubic-bezier(0.4, 0, 0.2, 1), transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    text-align: start;\n}\n\n.scl--dcl-step-content h3 {\n    color: var(--color-text-primary);\n    font-family: var(--primary-font);\n    margin: 0;\n    font-size: var(--font-size-body-sm);\n    font-weight: lighter;\n}\n\n.scl--dcl-step-content p {\n    font-size: var(--font-size-body-ssm);\n    color: var(--color-text-third);\n    margin: 0;\n    font-weight: lighter;\n    font-family: var(--primary-font);\n}\n\n/* Line */\n.scl--dacbs-stl-pos {\n    width: 100%;\n    position: relative;\n    padding-top: 24px;\n}\n\n.scl--dsp-stl-lin-cont {\n    width: 100%;\n    height: 3px;\n    background: linear-gradient(90deg,\n            rgba(255, 255, 255, 0.8),\n            rgba(185, 185, 185, 0.8));\n}\n\n/* Dots */\n.scl--dacbs-step-dots {\n    position: absolute;\n    top: 20px;\n    width: 100%;\n}\n\n.scl--dslc-step-inner {\n    position: absolute;\n    top: 0;\n    left: 200px;\n    right: 200px;\n    height: 100%;\n}\n\n.scl--sdt-step-dot {\n    position: absolute;\n    transform: translateX(-50%);\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    text-align: center;\n    min-width: 65px;\n}\n\n.scl--sdt-step-dot::before {\n    content: '';\n    width: 10px;\n    height: 10px;\n    background: rgba(125, 129, 135, 1);\n    display: block;\n    margin: 0 auto;\n    transition: 0.2s ease;\n}\n\n.scl--sdt-step-dot.active::before {\n    background: #fff;\n    transform: scale(1.3);\n}\n\n.scl--step-label {\n    margin-top: 8px;\n    font-size: 16px;\n    color: rgba(125, 129, 135, 1);\n    display: block;\n    font-family: var(--primary-font);\n}\n\n.scl--sdt-step-dot.active .scl--step-label {\n    color: var(--color-text-primary);\n    font-size: 16px;\n    font-family: var(--primary-font);\n}\n\n.scl--dcl-step-content[data-edge=\"start\"] {\n    transform: translateX(0);\n}\n\n.scl--dcl-step-content[data-edge=\"end\"] {\n    transform: translateX(-100%);\n}\n\n.scl--step-dots-track {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    transition: transform 0.4s ease;\n}\n\n.scl--step-dots-track.shifted {\n    transform: translateX(-12.5%);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
